import React, { useState, useEffect, useContext } from "react";
import MUIDataTable from "mui-datatables";
import Swal from "sweetalert2";
import { useUnidades } from "../../hooks/test/useUnidades";
import useCeo from "../../hooks/useCEO";
import { Input } from "../../components/General/Input";
import { Select } from "../../components/Select";
import { Loader } from "../../components/Loader";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faUser,
  faUserPlus,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import { IconButton, Popover, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import RemoveIcon from "@mui/icons-material/Remove";

import { AuthContext } from "../../context/authContext/authContext";
import { Spinner } from "../../components/Spinner";

const initialStateFormUsuarios = {
  usuario: "",
  name: "",
  email: "",
  password: "",
  id: "",
  users_num_empleado: "",
  negocio_id: 0,
  negocioId: 0,
  cedis_id: 0,
  roles_id: 0,
  telefono: "",
  activo: "",
};

export const TableroUsuarios = () => {
  const columns = [
    "Rol",
    "Nombre",
    "Cliente",
    "Cedis/hub",
    "Correo",
    "Telefono",
    "Estatus",
    {
      name: "Acciones",
      label: "Acciones",
      options: {
        display: true,
        download: false, // Esta columna no se incluirá en la descarga
        filter: false,
      },
    },
  ];

  useCeo({
    title: "MÓDULO DE ADMINISTRACIÓN DE USUARIOS",
    description: "Página de usuarios admon",
  });

  const {
    getUsuarios,
    putUsuario,
    postUsuario,
    getRoles,
    getUsuario,
    getNegocios,
    getCedisNegociosAll,
    deleteUser,
    // getHorarios,
  } = useUnidades();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialStateFormUsuarios);
  const { user } = useContext(AuthContext);
  // const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  // const [horarios, setHorarios] = useState([]);
  const [negocio, setNegocio] = useState([]);
  const [cedis, setCedis] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    reset();
  };
  const handleShow = () => setShow(true);

  useEffect(() => {
    const init = async () => {
      await loadInfo();
      await users();
    };

    init();
  }, []);

  const loadInfo = async () => {
    setLoading(true);
    let resp = await getRoles();
    if (resp.ok) setRoles(resp.roles);

    resp = await getNegocios();
    if (resp.ok) {
      if (user.negocio_id === 1 || user.negocio_id === 2) {
        setNegocio(resp.negocios);
      } else {
        let result = resp.negocios.find(
          ({ negocio_id }) => negocio_id === user.negocio_id,
        );
        setNegocio([result]);
      }
    }

    resp = await getCedisNegociosAll(user.negocio_id);
    if (resp.ok) setCedis([...resp.cedis]);

    setForm({
      ...form,
      negocio_id: user.negocio_id ? user.negocio_id : "",
    });

    setLoading(false);
  };

  const usarUsuario = async (id) => {
    setLoading(true);
    let resp = await getUsuario(id);

    if (resp.ok)
      setForm({
        ...form,
        password: "",
        ...resp.usuario,
      });
    setLoading(false);
  };

  const save = async (event) => {
    event.preventDefault();

    if (!form.id && !validaciones()) return;

    try {
      setLoading(true);

      const rolId = Number(form.roles_id);

      let resp;

      if (!form.id) {
        const data = {
          name: form.name,
          email: form.email,
          password: form.password,
          roles_id: form.roles_id,
          ...(form.users_num_empleado?.trim() && {
            users_num_empleado: form.users_num_empleado,
          }),
        };

        // Roles que requieren cliente
        if ([1, 6, 8].includes(rolId)) {
          data.negocioId = parseInt(form.negocio_id);
        }

        // Roles que requieren cedis y teléfono
        if (rolId === 4) {
          data.cedis_id = parseInt(form.cedis_id);
          data.telefono = form.telefono;
        }

        resp = await postUsuario(data);
      } else {
        const data = {
          usuario: form.usuario,
          id: form.id,
          name: form.name,
          email: form.email,
          roles_id: form.roles_id,
          activo: form.activo,
          negocioId: parseInt(form.negocio_id) || "",
          cedis_id: parseInt(form.cedis_id) || "",
          telefono: form.telefono || "",

          ...(form.users_num_empleado?.trim() && {
            users_num_empleado: form.users_num_empleado,
          }),
        };

        // Sólo enviar password cuando se capture
        if (form.password?.trim()) {
          data.password = form.password;
        }

        resp = await putUsuario(data);
      }

      if (!resp.ok) {
        return Swal.fire({
          title: "No se pudo actualizar el usuario",
          text: resp.msg,
          icon: "error",
        });
      }

      Swal.fire({
        title: "Operación realizada correctamente",
        text: resp.msg,
        icon: "success",
      });

      handleClose();
      reset();
      users();
    } catch (error) {
      console.error("Error al guardar usuario:", error);

      Swal.fire({
        title: "Error",
        text: "Ocurrió un problema al procesar la solicitud",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setForm(initialStateFormUsuarios);
    setForm([]);
  };

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const validaciones = () => {
    if (!form.name?.trim()) {
      showToastError("Favor de insertar nombre de usuario");
      return false;
    }

    if (!form.email?.trim()) {
      showToastError("Favor de insertar email");
      return false;
    }

    // Solo requerida en alta
    if (!form.id && !form.password) {
      showToastError("Favor de insertar la contraseña");
      return false;
    }

    // Solo validar longitud en alta
    if (!form.id && form.password?.length < 8) {
      showToastError("La contraseña debe tener al menos 8 caracteres");
      return false;
    }

    if (!form.roles_id) {
      showToastError("Favor de seleccionar rol");
      return false;
    }

    const rolId = Number(form.roles_id);

    const perfiles = {
      1: {
        negocio: true,
      },
      6: {
        negocio: true,
      },
      8: {
        negocio: true,
      },
      4: {
        telefono: true,
        cedis: true,
      },
    };

    const perfil = perfiles[rolId] || {};

    if (perfil.negocio && !form.negocio_id) {
      showToastError("Es requerido el campo cliente");
      return false;
    }

    if (perfil.cedis && !form.cedis_id) {
      showToastError("Favor de elegir cedis/hub");
      return false;
    }

    if (perfil.telefono && !form.telefono) {
      showToastError("Es requerido el campo teléfono");
      return false;
    }

    if (
      perfil.telefono &&
      String(form.telefono).replace(/\D/g, "").length !== 10
    ) {
      showToastError("El número de teléfono debe tener 10 dígitos");
      return false;
    }

    return true;
  };

  const showToastError = (msj = "Ha ocurrido un error") => {
    toast.error(msj, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const statusUsuario = async (id_usuario, activo) => {
    let resp = await deleteUser({
      id: id_usuario,
      activo: activo,
    });
    if (resp.ok) {
      users();
      // await obtenerUsuarios();
      return Swal.fire({
        title: "¡Completado!",
        text: resp.msg,
        icon: "success",
      });
    } else {
      return Swal.fire({
        title: "No se pudo actualizar el usuario",
        text: resp.msg,
        icon: "error",
      });
    }
  };

  // UX-UI
  const ListPerfilamiento = ({ rolId = null }) => {
    const perfiles = {
      1: {
        negocio: true,
      },
      6: {
        negocio: true,
      },
      8: {
        negocio: true,
      },
      4: {
        telefono: true,
        cedis: true,
      },
    };

    const perfil = perfiles[rolId] || {};

    return (
      <>
        {perfil.cedis && (
          <div className="form-group col-sm-6 flex-column d-flex">
            <Select
              name="cedis_id"
              value={form.cedis_id}
              onChange={handleChange}
              labelText="Selecciona Cedis/Hub *"
              placeholder="Selecciona una cedis/hub"
              options={cedis.map((x) => ({
                value: x.cedis_id,
                text: x.nombre_cedis,
              }))}
              className="form-control mb-4"
            />
          </div>
        )}

        {perfil.telefono && (
          <div className="form-group col-sm-6 flex-column d-flex">
            <Input
              name="telefono"
              id="telefono"
              onChange={handleChange}
              value={form.telefono}
              type="number"
              labelText="Número de teléfono"
              placeholder="Escribe el número de teléfono"
              classNames="mb-4"
            />
          </div>
        )}

        {perfil.negocio && (
          <div className="form-group col-sm-6 flex-column d-flex">
            <Select
              name="negocio_id"
              value={form.negocio_id}
              onChange={handleChange}
              labelText="Cliente"
              placeholder="SELECCIONA"
              className="form-control selectCedis mb-4"
              options={negocio.map((x) => ({
                value: x.negocio_id,
                text: x.negocio_nombre,
              }))}
            />
          </div>
        )}
      </>
    );
  };

  const users = async () => {
    try {
      setLoading(true);

      const resp = await getUsuarios();

      if (resp.ok) {
        const array = [];

        resp.users.forEach((registro) => {
          const {
            id,
            name,
            email,
            telefono,
            negocio,
            roles_id,
            cedi,
            role,
            activo,
          } = registro;

          const rolId = Number(roles_id);
          const requiereNegocio = [1, 6, 8].includes(rolId);
          const requiereCedis = rolId === 4;

          array.push([
            role?.title || "N/A",
            name || "N/A",
            requiereNegocio
              ? negocio?.negocio_nombre || "Sin cliente"
              : "No requerido",
            requiereCedis ? cedi?.nombre_cedis || "Sin cedis" : "No requerido",
            email || "N/A",
            requiereCedis ? telefono || "Es requerido" : "No requerido",
            activo
              ? "Usuario habilitado"
              : "Usuario deshabilitado",
            <>
              <FontAwesomeIcon
                icon={faEdit}
                disabled={loading}
                className="fa-2x text-secondary cursor"
                title="Editar usuario"
                onClick={() => {
                  handleShow();
                  usarUsuario(id);
                }}
              />

              {activo ? (
                <FontAwesomeIcon
                  icon={faUser}
                  disabled={loading}
                  className="fa-2x text-success cursor"
                  title="Dar de baja usuario"
                  onClick={() => {
                    Swal.fire({
                      title: "¿Deseas deshabilitar la cuenta de usuario?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "¡Si!",
                      cancelButtonText: "No",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        statusUsuario(id, 0);
                      }
                    });
                  }}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faUser}
                  className="fa-2x text-danger cursor"
                  title="Habilitar usuario"
                  onClick={() => {
                    Swal.fire({
                      title: "¿Deseas habilitar la cuenta de usuario?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "¡Si!",
                      cancelButtonText: "No",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        statusUsuario(id, 1);
                      }
                    });
                  }}
                />
              )}
            </>,
          ]);
        });

        setData(array);
      }
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
      showToastError("Ocurrió un error al consultar los usuarios");
    } finally {
      setLoading(false);
    }
  };

  const options = {
    download: data.length > 0,
    selectableRows: "none",
    responsive: "standard", // mejor para tablas anchas
    fixedHeader: true, // mantiene header visible al hacer scroll
    customToolbar: () =>
      !loading ? ( // solo se muestra cuando ya cargó
        <ToolbarPopup
          handleChange={handleChange}
          setActiModalUsuario={setShow}
        />
      ) : null,
    downloadOptions: {
      filename: "usuarios.csv",
      // separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
      CharacterData: "utf-8",
      CharSet: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };
  // Toolbar con popup que recibe props
  const ToolbarPopup = ({ handleChange, setActiModalUsuario }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) =>
      setAnchorEl(anchorEl ? null : event.currentTarget);

    const open = Boolean(anchorEl);
    const id = open ? "popup-empty" : undefined;

    return (
      <>
        <IconButton
          onClick={() => setActiModalUsuario(true)}
          title="Crear Usuario"
        >
          <AddIcon />
        </IconButton>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        ></Popover>
      </>
    );
  };

  return (
    <>
      {loading && <Spinner />}
      <MUIDataTable
        title={"Usuarios en Bitacora"}
        data={data}
        columns={columns}
        options={options}
        onDownload={(buildHead, buildBody, columns, data) => {
          return "\uFEFF" + buildHead(columns) + buildBody(data);
        }}
      />

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <form className="form-card" onSubmit={save}>
          <Modal.Header closeButton>
            <Modal.Title>
              {!form.id ? "Crear usuario" : "Actualizar usuario"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-between text-left">
              <div className="form-group col-sm-6 flex-column d-flex">
                {" "}
                <Input
                  name="name"
                  id="name"
                  onChange={handleChange}
                  value={form.name}
                  type="text"
                  // required
                  labelText={"Nombre del usuario"}
                  placeholder={"Escribe el nombre del usuario"}
                  classNames="mb-4"
                  disabled={form.id ? true : false}
                ></Input>{" "}
              </div>
              <div className="form-group col-sm-6 flex-column d-flex">
                {" "}
                <Input
                  name="users_num_empleado"
                  id="users_num_empleado"
                  onChange={handleChange}
                  value={form.users_num_empleado}
                  type="number"
                  labelText={"Número de empleado"}
                  placeholder={"Escribe el número de empleado"}
                  classNames="mb-4"
                ></Input>{" "}
              </div>
            </div>
            <div className="row justify-content-between text-left">
              <div className="form-group col-sm-6 flex-column d-flex">
                {" "}
                <Select
                  name="roles_id"
                  value={form.roles_id}
                  className="form-control mb-4"
                  onChange={handleChange}
                  labelText="Rol del usuario"
                  placeholder="SELECCIONA"
                  // required
                  options={roles.map((x) => {
                    return {
                      value: x.id,
                      text: x.title,
                    };
                  })}
                ></Select>{" "}
              </div>
              <ListPerfilamiento rolId={parseInt(form.roles_id)} />
            </div>
            <div className="row justify-content-between text-left"></div>
            <div className="row justify-content-between text-left">
              <div className="form-group col-sm-6 flex-column d-flex">
                {" "}
                <Input
                  name="password"
                  value={form.password}
                  id="password"
                  onChange={handleChange}
                  type="password"
                  labelText={"Contraseña"}
                  placeholder={
                    !form.id
                      ? "Escribe tu contraseña"
                      : "Escribe la contraseña si desea cambiarla"
                  }
                  classNames="mb-4"
                  // required={!form.id}
                ></Input>{" "}
              </div>
              <div className="form-group col-sm-6 flex-column d-flex">
                {" "}
                <Input
                  name="email"
                  id="email"
                  onChange={handleChange}
                  value={form.email}
                  type="email"
                  // required
                  labelText={"Correo electronico"}
                  placeholder={"Escribe el correo del usuario"}
                  classNames="mb-4"
                ></Input>{" "}
              </div>
            </div>
            <br></br>
            <div className="row justify-content-center p-1">
              <div className="form-group col-sm-6"> </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              id="liberarSalida"
              type="submit"
              disabled={loading ? true : false}
              className="btn btn-lg liberarSalida"
              style={{ background: "#ffcd00" }}
            >
              <FontAwesomeIcon icon={faSave} />
              &nbsp;{" "}
              {loading ? "Cargando..." : form.id ? "Actualizar" : "Guardar"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
